<script lang="ts">
    import { onMount } from "svelte";
    import { translate } from "@/utils/format";
    import { getSponsoredCtx } from "../../state/sponsored.svelte";

    const sponsored = getSponsoredCtx();

    const pm = $derived(sponsored.billing.paymentMethod);
    const pmLabel = $derived(
        pm
            ? pm.type === "sepa_debit"
                ? `SEPA ···· ${pm.last4}`
                : `${(pm.brand || "Tarjeta").toUpperCase()} ···· ${pm.last4}`
            : "",
    );

    onMount(() => {
        void sponsored.load();
    });
</script>

<div class="referrals__stripe billingCard">
    <h3>
        {translate("PARTNER_BILLING_TITLE", "Método de pago")}
    </h3>
    <p class="billingCard__hint">
        {translate(
            "PARTNER_BILLING_HINT",
            "Se usa para cobrar las suscripciones que pagas por tus usuarios. Es independiente de Stripe Connect, donde recibes tus comisiones.",
        )}
    </p>

    {#if sponsored.loading && !sponsored.loaded}
        <p class="billingCard__hint">
            {translate("LOADING_CONTENT", "Cargando tu contenido...")}
        </p>
    {:else if sponsored.billing.hasDefaultPaymentMethod && pm}
        <div class="billingCard__pm">
            <i
                class={pm.type === "sepa_debit"
                    ? "fal fa-university"
                    : "fal fa-credit-card"}
                aria-hidden="true"
            ></i>
            <div>
                <strong class="mono">{pmLabel}</strong>
                {#if pm.expMonth && pm.expYear}
                    <span class="billingCard__exp">
                        {translate("PARTNER_BILLING_EXPIRES", "Caduca")}
                        {String(pm.expMonth).padStart(2, "0")}/{String(
                            pm.expYear,
                        ).slice(-2)}
                    </span>
                {/if}
            </div>
        </div>
    {:else}
        <p class="warning">
            {translate(
                "PARTNER_BILLING_NONE",
                "Aún no has guardado ningún método de pago.",
            )}
        </p>
    {/if}

    <div class="referrals__buttons">
        {#if sponsored.billing.hasDefaultPaymentMethod}
            <button
                type="button"
                class="button"
                disabled={sponsored.portalBusy}
                onclick={sponsored.openPortal}
            >
                {translate(
                    "PARTNER_BILLING_MANAGE",
                    "Gestionar método de pago y facturas",
                )}
            </button>
        {:else}
            <button
                type="button"
                class="button --primary"
                disabled={sponsored.portalBusy}
                onclick={sponsored.startSetup}
            >
                {translate("PARTNER_BILLING_ADD", "Añadir método de pago")}
            </button>
        {/if}
    </div>
</div>
